exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-210f3a9a]{width:300px}.el-dropdown-link[data-v-210f3a9a]{cursor:pointer;color:#409eff;font-size:12px}.el-icon-arrow-down[data-v-210f3a9a]{font-size:12px}.tabBox_tit[data-v-210f3a9a]{width:60%;font-size:12px !important;margin:0 2px 0 10px;letter-spacing:1px;padding:5px 0;-webkit-box-sizing:border-box;box-sizing:border-box}.mt20[data-v-210f3a9a]{margin-top:20px}.demo-image__preview[data-v-210f3a9a]{position:relative;padding-left:40px}.demo-image__preview .el-image[data-v-210f3a9a],.el-image__error[data-v-210f3a9a]{position:absolute;left:0}.maxw180[data-v-210f3a9a]{display:inline-block;max-width:180px}", ""]);

// exports
